import React from 'react'
import './settingLeftFunction.css'

class SettingFunction extends React.Component {
    constructor(props) {
        super(props)
    }

    handleShowMyPage = () => {
        this.props.showMyPage();
    };

    handleShowPwdPage = () => {
        this.props.showPwdPage();
    };

    render(){
        return(
            <div className='div_function_style'>
                <button onClick={this.handleShowMyPage} className='button_style btn1'>用户信息</button>
                <button onClick={this.handleShowPwdPage} className='button_style btn2'>修改密码</button>
                <button className='button_style btn3'>购买记录</button>
            </div>
        );
    }
}

export default SettingFunction